(function ($, njm) {
    'use strict';

    njm.views.headerDesktop = Backbone.View.extend({

        events: {
            'click .expendable li label': 'selectMenuItem',
            //'click .search a': 'submitSearch',
            'click .login': 'openLogin',
			'keydown .expendable li label': 'selectMenuItemKey',
			'keydown .overlay *': 'overlayKey',
			'keydown .login': 'loginKey',
			'keydown .login *': 'loginKey'
			
        },

        // supported medias for this view
        medias: ['desktop'],

        /**
         * Initialize
         */
        initialize: function () {
            this.template = $('#comp-header-desktop').html();

            $('body').click(this.clickToClose.bind(this));

            // Render
            this.render();
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
            this.$header = this.$('.header');
            this.$items = this.$('.expendable li');
            this.$submenus = this.$('.submenu');
            this.$login = this.$('.login');
        },

        /**
         * Select Menu Item
         * @param {Object} e
         */
        selectMenuItem: function (e) {
            this.$thisItem = $(e.currentTarget).parent();

            this.$items.not(this.$thisItem).removeClass('selected')
            $(e.currentTarget).parent().toggleClass('selected');

            if (this.$thisItem.hasClass('selected')) {
                // open selected sub-menu
				this.$thisItem.find('label').attr('aria-expanded','true');
                this.$header.addClass('active');
                this.$submenus.removeClass('show')
                    .filter('[data-name=' + $(e.currentTarget).parent().data('name') + ']')
                    .addClass('show');
            } else {
                // close selected sub-menu
                this.$header.removeClass('active');
                this.$submenus.removeClass('show');
				this.$thisItem.find('label').attr('aria-expanded','false');
				
            }
        },
		
		selectMenuItemKey: function (e) {
			var key = e.which, target = $(e.target);
			
			if (key === 13) { //enter key
				target.trigger('click');
				this.$('.overlay .submenu.show a').eq(0).focus();
			}
		},

        /**
         * Open/Close Login box
         */
        openLogin: function (e) {
            this.$thisItem = $(e.currentTarget);
            if (this.$thisItem.hasClass('open')) {
                // close login menu
                this.$thisItem.removeClass('open').find('.login-box').slideUp();
				this.$login.focus().attr('aria-expanded','false');
            } else {
                // close selected sub-menu
                this.$thisItem.addClass('open').find('.login-box').slideDown();
				this.$login.focus().attr('aria-expanded','true');
            }
        },
		
		overlayKey: function (e) {
			var key = e.which, openMenu = this.$('.expendable li.selected label');
			
			if (key === 27) { //escape key
				$('body').trigger('click');
				openMenu.focus().attr('aria-expanded','false');
			}
		},
		
		loginKey: function (e) {
			var key = e.which, target = $(e.target);
			
			if (key === 13) { //enter key
				target.find('label').trigger('click');
				this.$('.login-box a').eq(0).focus();
			}
			
			if (key === 27) { //escape key
				$('body').trigger('click');
				this.$login.focus().attr('aria-expanded','false');
			}
		},

        /**
         * Click to close
         * @param {Object} e
         */
        clickToClose: function (e) {
            if (!$(e.target).closest('.expendable label').length) {
                this.closeMenu();
            }

            if (!$(e.target).closest('.login').length) {
                this.$login.removeClass('open').find('.login-box').slideUp();
				this.$login.attr('aria-expanded','false');
            }
        },

        /**
         * Close Menu
         */
        closeMenu: function () {
            this.$items.removeClass('selected');
            this.$header.removeClass('active');
			this.$submenus.removeClass('show');
        },

        /**
         * Submit search
         */
        submitSearch: function (e) {
            if (e.type === 'click') {
                e.preventDefault();
                var form = this.$('.search form')[0];
                form.submit();
            }
        }
    });
})(jQuery, njm);
